import React, { useState, useEffect } from 'react'
import { Dialog, Table, toaster, Button } from 'evergreen-ui'
import RoundBtn from '../../Components/RoundBtn';
import ActivityTypeForm from './ActivityTypeForm'
import { Heading } from 'evergreen-ui/commonjs/typography';
import { connect } from 'react-redux'
import axios from '../../Utils/axios';
import { unsetLoading, setLoading } from '../../Redux/reducers/loading';
const ActivityType = ({
  company, dispatch
}) => {

  const [isModalVisible, setVisibility] = useState(false)
  const [activityType, setActivityType] = useState(null)
  const [types, setTypes] = useState([])


  useEffect(() => {
    getTaskType()
  }, [])

  const createOrEdit = (activityType = null) => {
    setActivityType(activityType)
    setVisibility(true)
  }

  const getTaskType = async () => {

    try {
      const { data } = await axios.get(`/company/activities`)

      setTypes(data.activities)
    }
    catch (error) {
      toaster.danger('Erro ao buscar tipos de atividade')
    }
    finally {

    }
  }

  const handleEdit = async ({ __id__, name, active }) => {
    dispatch(setLoading())
    try {
      await axios.put(`/company/activities/${__id__}`,
        { name, active }
      )
      await getTaskType()
      setVisibility(false)
      toaster.success('Tipo de atividade alterado com sucesso')
    } catch (error) {
      toaster.error('Falha ao alterar tipo de atividade')
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  const handleSave = async (task) => {
    dispatch(setLoading())
    try {

      const { data } = await axios.post(`/company/activities`,
        task
      )
      setVisibility(false)
      toaster.success(
        'Sucesso ao cadastrar atividade', {
          description: 'Sua atividade foi cadastrada com sucesso.',
          duration: 10,
        }
      )

      setTypes([...types, data])
    }
    catch (error) {
      toaster.danger('Falha ao inserir tipo de atividade')
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  return (
    <React.Fragment>
      <Heading size={600}> Tipo de Atividade </Heading>

      <Table style={{ marginTop: 15 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Descrição da atividade
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Status
          </Table.TextHeaderCell>
          <Table.TextHeaderCell width={220} flex="none">
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={600}>
          {types.map(taskType => (
            <Table.Row key={taskType.__id__}>
              <Table.TextCell>{taskType.name}</Table.TextCell>
              <Table.TextCell>{taskType.active ? 'Ativo' : 'Inativo'}</Table.TextCell>
              <Table.TextCell width={220} flex='none' >
                <Button
                  iconBefore='edit'
                  marginRight={20}
                  onClick={() => createOrEdit(taskType)}
                > Editar </Button>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>

      </Table >
      <RoundBtn action={() => createOrEdit()} />

      <Dialog
        shouldCloseOnOverlayClick={false}
        isShown={isModalVisible}
        title="Cadastro do tipo de Atividade"
        intent="danger"
        onCloseComplete={() => setVisibility(false)}
        confirmLabel="Delete Something"
        hasFooter={false}
      >
        <ActivityTypeForm
          activityType={activityType}
          save={(activity) => handleSave(activity)}
          handleEdit={(activity) => {
            handleEdit(activity)
          }}
        />
      </Dialog>

    </React.Fragment >
  )
}

const mapStateToProps = ({ auth, loading }) => ({
  company: auth.account,
})
export default connect(mapStateToProps)(ActivityType)